import { render, staticRenderFns } from "./CollegeView.vue?vue&type=template&id=29cecff0&"
import script from "./CollegeView.vue?vue&type=script&lang=js&"
export * from "./CollegeView.vue?vue&type=script&lang=js&"
import style0 from "./CollegeView.vue?vue&type=style&index=0&id=29cecff0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports